import { useQuery } from "react-query";
import { RestError } from "../../../services/rest-service/RestService";
import { IPolledDeviceSectionsModel } from "../../../services/summary-listing-data-service/DeviceSummaryModels";
import SummaryListingDataService from "../../../services/summary-listing-data-service/SummaryListingDataService";
import { BaseUseQueryParameters } from "../../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseDeviceSummaryDataParameters = {
    customerID: number,
    groupID: number,
    configurationID?: number;
} & BaseUseQueryParameters<IPolledDeviceSectionsModel>;

export function useDeviceSummaryData({
    customerID,
    groupID,
    configurationID,
    offline,
    enabled,
    onError,
    onSuccess,
    refreshSeconds
}: UseDeviceSummaryDataParameters) {
    return useQuery<IPolledDeviceSectionsModel, RestError>(
        keys.summaryData(customerID, groupID, offline ?? false, configurationID),
        ({ signal }) => {
            return SummaryListingDataService.getDeviceData(customerID, groupID, offline ?? false, configurationID, "", signal);
        },
        {
            enabled,
            onError,
            onSuccess,
            refetchInterval: refreshSeconds ? refreshSeconds * 1000 : false
        }
    );
}
